module.exports = __webpack_public_path__ + "img/Sessies.3280719c.png";